// extracted by mini-css-extract-plugin
export var $animation_name = "Interstital-module--$animation_name--3368a";
export var Interstital = "Interstital-module--Interstital--5c79c";
export var Interstital__container = "Interstital-module--Interstital__container--cda9d";
export var Interstital__container___bubble = "Interstital-module--Interstital__container___bubble--27724";
export var Interstital__waveWrapper = "Interstital-module--Interstital__waveWrapper--60c62";
export var moveForever = "Interstital-module--move-forever--3c570";
export var parallax = "Interstital-module--parallax--d36f4";